import React from 'react'

const NotFound = () => <div>Whoops... we can't find what you're looking for.</div>

export default NotFound